var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-component"},[_c('keep-alive',{attrs:{"max":"10"}},[_c('router-view',{key:`${_vm.$route.name}-${_vm.$route.meta.key}`,attrs:{"name":"keepAlive"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }